import { Mixpanel } from 'mixpanel-browser'

export class MixpanelInAppMessaging {
  origin: string | null
  messageSource: Window | null
  mixpanel: Mixpanel

  constructor(mixpanel: Mixpanel) {
    this.mixpanel = mixpanel
    this.messageSource = null
    this.origin = null
  }

  checkForMessages = (records: MutationRecord[]) => {
    let addedMixpanelNotificationWrapper = false
    let removedMixpanelNotificationWrapper = false

    records.forEach(record => {
      record.addedNodes.forEach(node => {
        if (
          node instanceof HTMLElement &&
          node.id === 'mixpanel-notification-wrapper'
        ) {
          addedMixpanelNotificationWrapper = true
        }
      })

      record.removedNodes.forEach(node => {
        if (
          node instanceof HTMLElement &&
          node.id === 'mixpanel-notification-wrapper'
        ) {
          removedMixpanelNotificationWrapper = true
        }
      })
    })

    if (addedMixpanelNotificationWrapper) {
      this.sendMessage('display', true)
    }

    if (removedMixpanelNotificationWrapper) {
      this.sendMessage('display', false)
    }
  }

  handleMessage = (messageEvent: MessageEvent) => {
    this.messageSource = messageEvent.source as Window | null
    this.origin = messageEvent.origin

    if (messageEvent.data.subject === 'identifyUser') {
      this.identifyUser(messageEvent.data.userId)
    }
  }

  identifyUser = (userId: string) => {
    this.mixpanel.identify(userId)
  }

  init = () => {
    if (typeof process.env.REACT_APP_MIXPANEL_TOKEN === 'undefined') {
      throw new Error('Missing Mixpanel API token')
    }

    this.mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
      // eslint-disable-next-line @typescript-eslint/camelcase
      batch_requests: true,
      debug: process.env.NODE_ENV !== 'production',
      // eslint-disable-next-line @typescript-eslint/camelcase
      disable_cookie: true,
      // eslint-disable-next-line @typescript-eslint/camelcase
      api_host:
        process.env.REACT_APP_DEV_BASE_URL ||
        'https://lastpass.com/product-messaging',
      // eslint-disable-next-line @typescript-eslint/camelcase
      inapp_link_new_window: true
    })

    window.addEventListener(
      'message',
      event => this.handleMessage(event),
      false
    )
    // @ts-ignore
    window.open = url => {
      this.sendMessage('goTo', url)
    }

    const observer = new MutationObserver(this.checkForMessages)
    observer.observe(document.querySelector('body') as Node, {
      childList: true
    })
  }

  sendMessage = (subject: string, value) => {
    if (!this.messageSource || !this.origin) {
      throw new Error('No target defined send the message to')
    }

    this.messageSource.postMessage({ subject, value }, this.origin)
  }
}
